const en = {
  translation: {
    salutation: "Hi there",
    introduction: "I'm",
    introudction_job_title: "And I'm a",
    developer: "developer",
    download: "download",
    cv: "CV",
    select: "select",
    experiance_years: "{{years}} years",
    of_experiance: "of experience",
    my_portofolio: "my portfolio",
    portofolio: "projects",
    testimonials: "volunteering",
    all: "all",
    about: "about",
    services: "services",
    how_i_can_help: "how I can help",
    skill_level_question: "what is my skill level",
    see_more: "see more",
    achievements: "achievements",
    personal_info: "Personal Info",
    experience: "Experience",
    education: "Education",
    skills_and_technology: "skills and technology",
    hide: "hide",
    get_in_touch: "get in touch",
    send_message: "send message",
    message: "message",
    subject: "subject",
    your_name: "your name",
    email_address: "email address",
    talk_statment: "let's talk about your software project",
    like_form_question: "prefer direct contact",
    send_me: "send me an",
    email: "email",
    language: "language",
    home_page: "home page",
    me: "me",
    my_experience: "my experience",
    coming_soon: "coming soon",
    this_page_is_under_construction: "this page is under construction",
    is_required_field: "{{field}} is required field",
  },
};

export default en;
